import React, { useState, useEffect, FormEvent } from 'react';
import { Container, Button, Input, Form, Message, Checkbox, Loader } from 'semantic-ui-react';
import dayjs from 'dayjs';
import Globals from '../Globals';
import 'dayjs/locale/fr'; // import locale
import { IGroupBookingQuote } from '../Models/IGroupBookingQuote';
import QuotesApi from '../api/QuotesApi';

dayjs.locale('fr');

const ValidationDevisGroupes = () => {
  const searchParams = new URLSearchParams(document.location.search);
  const bookingId = searchParams.get('b');
  const quoteId = searchParams.get('q');
  const [quote, setQuote] = useState<IGroupBookingQuote>();
  const [canSubmit, setCanSubmit] = useState<boolean>(true);
  const [sending, setSending] = useState<boolean>(false);
  const [sent, setSent] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [confirmCGV, setConfirmCGV] = useState<boolean>(false);
  const qApi = new QuotesApi();

  useEffect(() => {
    if (bookingId && quoteId) {
      if (!quote) {
        const qApi = new QuotesApi();
        qApi.getGroupBooking(bookingId, quoteId)
          .then((res) => {
            if (res.data.quoteValidationDate) {
              setErrorMessage(`Vous ne pouvez plus mettre à jour le devis n°${quoteId} (déjà validé par retour signé)`);
              setCanSubmit(false);
            }
            else if (dayjs(res.data.quoteDueDate ? res.data.quoteDueDate : res.data.created) < dayjs()) {
              setErrorMessage(`Vous ne pouvez plus mettre à jour le devis n°${quoteId} (date de validité dépassée)`);
              setCanSubmit(false);
            }
            else if (res.data.status === "REJECTED") {
              setErrorMessage(`Vous ne pouvez plus mettre à jour le devis n°${quoteId} (devis annulé)`);
              setCanSubmit(false);
            }

            setQuote(res.data);
          }).catch(() => {
            // Error
            setErrorMessage(`Devis inconnu, veuillez-nous contacter par mail.`);
          })
      }
    } else {
      setErrorMessage(`Devis inconnu, veuillez-nous contacter par mail.`);
    }
  }, [quote, bookingId, quoteId]);

  const handleImportSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (bookingId && quoteId) {
      const formData = new FormData(e.currentTarget);
      const file = formData.get('file') as File;
      if (!file || file.size === 0 || !file.type) {
        setErrorMessage('Vous devez sélectionner un devis au format PDF ou image depuis votre poste.');
        return;
      }
      setErrorMessage(undefined);
      setSending(true);
      qApi.uploadGroupBookingSignedQuote(bookingId, quoteId, file)
        .then(() => {
          setSent(true);
        }).catch(() => {
          setErrorMessage(`Une erreur est survenue lors de l'envoi du fichier. Retentez plus tard ou envoyez-le nous sur ${Globals.Email}.`);
        }).finally(() => {
          setSending(false);
        });
    }
    return
  }

  return (<Container fluid>
    <h3>Retour de votre devis signé</h3>
    {bookingId && quoteId && !quote && (<Loader active inline>Chargement du devis...</Loader>)}
    {bookingId && quoteId && quote && (<Form onSubmit={handleImportSubmit}>
      <h4>Devis concerné: <i>{quote.quoteId}</i>.</h4>
      <div style={{ paddingBottom: 15 }}>Vous pouvez nous retourner votre devis signé <b>au format PDF ou image (jpg, png)</b> avec la mention "Bon pour accord" en le chargeant depuis votre poste et en cliquant sur "Envoyer le devis signé".</div>
      <div style={{ paddingBottom: 15 }}><Input type="file" name="file" accept="application/pdf,image/*" disabled={sending || sent || !canSubmit}></Input></div>
      <div style={{ paddingBottom: 15 }}><Checkbox checked={confirmCGV} onChange={(ev, newVal) => { setConfirmCGV(newVal.checked || false) }} disabled={sending || sent || !canSubmit} label="Je confirme avoir pris connaissance des conditions générales de ventes jointes au courrier électronique de demande de devis." /></div>
      <div style={{ paddingBottom: 15 }}><Button primary type="submit" loading={sending} disabled={!confirmCGV || sending || sent || !canSubmit}>Envoyer le devis signé</Button></div>
      {sent && (<Message positive>Votre devis signé nous a bien été retourné, vous allez recevoir une confirmation par mail depuis notre adresse <b>reservations@fermerainbow.com</b>. Si vous ne la recevez pas, pensez à vérifier dans les spams et le cas échéant contactez-nous sur {Globals.Email}.<br />Merci et à bientôt !</Message>)}
    </Form>)}
    {errorMessage && (<Message negative>{errorMessage}</Message>)}
  </Container>);
}

export default ValidationDevisGroupes;
